import { useDispatch, useSelector } from 'react-redux';

import type { BackofficeAppDispatch, BackofficeRootState } from '../store';

export const useBackofficeDispatch = useDispatch.withTypes<BackofficeAppDispatch>();
export const useBackofficeSelector = useSelector.withTypes<BackofficeRootState>();
